/**
 * BlockRegistry — mapeia BlockType para sua definicao (render + meta).
 */

import type { BlockDefinition, BlockRegistry } from './types';
import type { BlockType } from '@/types/tenant.types';
import { heroBlockDefinition } from './HeroBlock';
import {
  bioBlockDefinition,
  proposalsBlockDefinition,
  achievementsBlockDefinition,
  customTextBlockDefinition,
  numberCardBlockDefinition,
  spacerBlockDefinition,
  dividerBlockDefinition,
} from './ContentBlocks';
import {
  mandatesBlockDefinition,
  approvedProjectsBlockDefinition,
  galleryBlockDefinition,
  socialBlockDefinition,
} from './PoliticalBlocks';
import {
  ctaBlockDefinition,
  videoBlockDefinition,
  countdownBlockDefinition,
  testimonialsBlockDefinition,
} from './InteractionBlocks';

export const BLOCK_REGISTRY: BlockRegistry = {
  hero: heroBlockDefinition as BlockDefinition,
  bio: bioBlockDefinition as BlockDefinition,
  proposals: proposalsBlockDefinition as BlockDefinition,
  achievements: achievementsBlockDefinition as BlockDefinition,
  mandates: mandatesBlockDefinition as BlockDefinition,
  'approved-projects': approvedProjectsBlockDefinition as BlockDefinition,
  gallery: galleryBlockDefinition as BlockDefinition,
  video: videoBlockDefinition as BlockDefinition,
  cta: ctaBlockDefinition as BlockDefinition,
  social: socialBlockDefinition as BlockDefinition,
  'custom-text': customTextBlockDefinition as BlockDefinition,
  'number-card': numberCardBlockDefinition as BlockDefinition,
  countdown: countdownBlockDefinition as BlockDefinition,
  testimonials: testimonialsBlockDefinition as BlockDefinition,
  spacer: spacerBlockDefinition as BlockDefinition,
  divider: dividerBlockDefinition as BlockDefinition,
};

export function getBlockDefinition(type: BlockType): BlockDefinition | null {
  return BLOCK_REGISTRY[type] ?? null;
}

/**
 * Lista de blocos disponiveis para a biblioteca do editor, ordenada por
 * categoria. Util pro painel "Adicionar bloco".
 */
export function getAllBlocks(): BlockDefinition[] {
  return Object.values(BLOCK_REGISTRY);
}

export function getBlocksByCategory(category: BlockDefinition['category']): BlockDefinition[] {
  return getAllBlocks().filter((b) => b.category === category);
}

export const BLOCK_CATEGORIES: { id: BlockDefinition['category']; label: string }[] = [
  { id: 'hero', label: 'Capa & destaque' },
  { id: 'content', label: 'Conteúdo' },
  { id: 'visual', label: 'Visual' },
  { id: 'interaction', label: 'Interação' },
  { id: 'layout', label: 'Layout' },
];
